import { render } from "./CreateSoundtrackForm.vue?vue&type=template&id=7f36e6d3"
import script from "./CreateSoundtrackForm.vue?vue&type=script&lang=js"
export * from "./CreateSoundtrackForm.vue?vue&type=script&lang=js"

import "./CreateSoundtrackForm.vue?vue&type=style&index=0&id=7f36e6d3&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__